<script>
import Layout from "../../layouts/main";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      searchQuery: "",
      products: [],
      currentPage: 1,
      itemsPerPage: 20,
      showPopup: false,
      showDeletePopup: false,
      file: null,
      imagePreview: null,
      newProduct: {
      },
      deleteProductId: null,
      isLoading: false,
      isDeleting: false
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product =>
        product.url.includes(this.searchQuery)
      );
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProducts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    }
  },
  methods: {
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    async fetchProducts() {
      try {
        const response = await fetch("https://humobarculinario.com/api/get_links.php");
        if (!response.ok) {
          throw new Error("Error al obtener los enlaces");
        }
        const data = await response.json();
        this.products = data.map(link => ({
          id: link.id,
          url: link.url,
          status: link.status,
          pos_id: link.pos_id,
          created_at: link.created_at,
          updated_at: link.updated_at
        }));
      } catch (error) {
        console.error("Error fetching links:", error);
        alert("Hubo un error al cargar los enlaces. Intente de nuevo.");
      }
    },
    // Manejar la selección de la imagen
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.imagePreview = URL.createObjectURL(this.file);
    },
    // Enviar la imagen y los datos al servidor
    async addProduct() {
      if (!this.file) {
        alert("Selecciona una imagen antes de subir.");
        return;
      }

      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("pos_id", this.newProduct.pos_id);

      this.isLoading = true;
      try {
        const response = await fetch("https://humobarculinario.com/api/upload_image.php", {
          method: "POST",
          body: formData
        });

        const result = await response.json();

        if (result.success) {
          alert("Imagen subida correctamente");
          console.log("URL de la imagen:", result.url);
          this.showPopup = false;
          this.fetchProducts();
        } else {
          alert("Error: " + result.error);
        }
      } catch (error) {
        console.error("Error al subir la imagen:", error);
      } finally {
        this.isLoading = false;
      }
    },
    openDeletePopup(productId) {
      this.deleteProductId = productId;
      this.showDeletePopup = true;
    },
    async deleteProduct() {
      this.isDeleting = true;
      try {
        const response = await fetch(`https://humobarculinario.com/api/delete_image.php?id=${this.deleteProductId}`, {
          method: "POST"
        });
        if (!response.ok) {
          throw new Error("Error al eliminar imagen");
        }
        alert("Imagen eliminada exitosamente");
        this.showDeletePopup = false;
        this.fetchProducts();
      } catch (error) {
        console.error("Error al eliminar imagen:", error);
        alert("Hubo un error al eliminar la imagen. Intente de nuevo.");
      } finally {
        this.isDeleting = false;
      }
    }
  },
  mounted() {
    this.fetchProducts();
  }
};
</script>

<template>
  <Layout>
    <div class="menu-container">
      <div class="header">
        <h5>Subir Imagen</h5>
        <button class="add-button" @click="showPopup = true">SUBIR NUEVA IMAGEN</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Imagen</th>
            <th>Fecha Subida</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(link, index) in paginatedProducts" :key="index">
            <td>{{ link.id }}</td>
            <td>
              <img :src="link.url" class="image-preview" v-if="isImage(link.url)" />
            </td>
            <td>{{ link.created_at }}</td>
            <td>
              <button class="icon-button" @click="openDeletePopup(link.id)">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="totalPages > 1">
        <button v-for="page in totalPages" :key="page" @click="changePage(page)" :class="{'active': page === currentPage}">
          {{ page }}
        </button>
      </div>
    </div>

    <!-- Popup para subir imagen -->
    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <h3>Subir Imagen</h3>
        <input type="file" @change="handleFileUpload" accept="image/*" required />
        <img v-if="imagePreview" :src="imagePreview" class="image-preview" />
        <div class="popup-buttons">
          <button class="add-button" @click="addProduct" :disabled="isLoading">
            {{ isLoading ? 'Subiendo...' : 'Subir' }}
          </button>
          <button class="cancel-button" @click="showPopup = false">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Popup para eliminar -->
    <div v-if="showDeletePopup" class="popup">
      <div class="popup-content">
        <h3>¿Eliminar esta imagen?</h3>
        <div class="popup-buttons">
          <button class="delete-button" @click="deleteProduct" :disabled="isDeleting">
            {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
          </button>
          <button class="cancel-button" @click="showDeletePopup = false">Cancelar</button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.menu-container {
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.add-button {
  background-color: purple;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.available {
  color: green;
  font-weight: bold;
}
.sold-out {
  color: red;
  font-weight: bold;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
  font-size: 16px;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.pagination button {
  margin: 2px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}
.pagination .active {
  background: purple;
  color: white;
}
/* Cargando overlay y spinner */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.loading-spinner {
  border: 4px solid #f3f3f3; /* Fondo gris claro */
  border-top: 4px solid purple; /* Color de la parte que gira */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 360px;
}
.popup label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}
.popup input, .popup select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.popup-buttons {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.add-button, .delete-button {
  background-color: #4e583c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}
.add-button:hover, .delete-button:hover {
  background-color: black;
}
.cancel-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  border: 1px solid black;
}
.cancel-button:hover {
  background-color: white;
  border: 1px solid black;
  color: black;
}
.image-preview {
  width: 300px;
  border-radius: 10px; /* Bordes redondeados opcionales */
  object-fit: cover; /* Asegura que la imagen se recorte y llene el espacio */
  display: block;
  margin: 10px auto; /* Centrar la imagen */
}
</style>